import { scrollToElement } from 'common/utils/scroll';
import { get } from 'common/utils/xhr';
import { findParentByAttribute, getLinkTargetUrl, getLinkTargetPath } from 'common/utils/domUtils';
import serviceDesignExpanders from 'marketing/components/serviceDesignerExpanders';
import trackEvent from '@99designs/utils/platform/trackEvent';
import trackLink from '@99designs/utils/platform/trackLink';
import FullscreenOverlay from 'marketing/components/FullscreenOverlay';

export default class FreelanceDesigners {
    constructor() {
        this.freelanceDesigners = document.querySelector('[data-freelance-designers]');
        this.freelanceDesignersSection = document.querySelector('#freelance_designers');
        this.paginationLinkAttr = 'data-page-number';
        this.spinner = document.querySelector('[data-freelance-designers-spinner]');
        this.fullscreenOverlayElement = document.querySelector('[data-fullscreen-overlay-id="logo-design-freelancer-modal"]');

        this.handlePagination();
        serviceDesignExpanders();
        this.initialisePortfolioExpanderTracking();
    }

    handlePagination() {
        for (const link of this.freelanceDesigners.querySelectorAll('[' + this.paginationLinkAttr + ']')) {
            link.addEventListener('click', (e) => {
                e.preventDefault();

                if (!this.isCurrentPage(link)) {
                    scrollToElement(this.freelanceDesignersSection, 22, 0);
                    const page = link.getAttribute(this.paginationLinkAttr);
                    this.getDesigners(page);

                    trackEvent('Clicked Element On Product Page', {
                        element_id: 'clicked-pagination',
                        section_id: 'freelance-designers',
                        category: 'logo-design',
                        page: page
                    });
                }
            });
        }

        const paginationMoreButton = this.freelanceDesignersSection.querySelector('[data-fullscreen-overlay-open]');

        this.initialiseFullScreenOverlay();

        paginationMoreButton.addEventListener('click', () => {
            this.setModalContent();

            trackEvent('Clicked Element On Product Page', {
                element_id: 'pagination-more-button',
                section_id: 'freelance-designers',
                category: 'logo-design',
            });
        });
    }

    initialiseFullScreenOverlay() {
        new FullscreenOverlay({
            element: this.fullscreenOverlayElement,
            options: {
                fixedViewport: true
            }
        });
    }

    setModalContent() {
        const modalElement = this.fullscreenOverlayElement.querySelector('[data-fullscreen-overlay-modal-content]');
        const modalContentContainer = this.freelanceDesignersSection.querySelector('[data-modal-content-container]');

        modalElement.innerHTML = modalContentContainer.innerHTML;

        const discoverDesignersLink = modalElement.querySelector('[data-discover-designers-link]');
        const defaultData = Object.assign(global.trackParams, {
            section_id: 'freelance-designers',
        });

        trackLink(discoverDesignersLink, 'Clicked Link On Product Page', Object.assign({}, defaultData, {
            target_url: getLinkTargetUrl(discoverDesignersLink),
            target_path: getLinkTargetPath(discoverDesignersLink)
        }));
    }

    isCurrentPage(link) {
        const parent = findParentByAttribute(link, 'data-active');

        return Boolean(parent);
    }

    getDesigners(page = 1) {
        this.startLoading();

        const xhr = get('/start/xhr/freelance-designers').query({
            page: page
        });

        xhr.end((error, res) => {
            if (error) {
                this.stopLoading();
            } else {
                this.freelanceDesigners.innerHTML = res.body.html;
                this.handlePagination();
                serviceDesignExpanders();
                this.stopLoading();
                this.reinitialiseLinkTracking();
            }
        });
    }

    startLoading() {
        this.spinner.removeAttribute('data-hidden');
    }

    stopLoading() {
        this.spinner.setAttribute('data-hidden', '');
    }

    initialisePortfolioExpanderTracking() {
        const expanderLinks = this.freelanceDesignersSection.querySelectorAll('[data-expand-link]');

        Array.from(expanderLinks).forEach(link => {
            link.addEventListener('click', () => {
                const action = link.hasAttribute('data-expanded') ? 'hide' : 'show';

                trackEvent('Clicked Element On Product Page', {
                    element_id: `freelance-${action}-portfolio-button`,
                    section_id: 'freelance-designers',
                    category: 'logo-design',
                });
            });
        });
    }

    reinitialiseLinkTracking() {
        this.initialisePortfolioExpanderTracking();

        if (window.userBehaviourTracking) {
            window.userBehaviourTracking.setupTrackLink(
                this.freelanceDesignersSection.querySelectorAll('a')
            );
        }
    }
}



// WEBPACK FOOTER //
// ./js/marketing/components/FreelanceDesigners.js